import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { HttpTokenInterceptor } from '@core/interceptors';
import { environment } from '@environments/environment';
import { FilterMatchMode, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { provideApiConfiguration } from '../api/api-configuration';
import { routerOptions, routes } from './app.routes';
import { MyPreset } from './app.theme';
import { AuthBootstrapService } from './core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideApiConfiguration(environment.API_URL),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withRouterConfig(routerOptions)),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (bootstrap: AuthBootstrapService) => () =>
        bootstrap.initialize(),
      deps: [AuthBootstrapService],
      multi: true,
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.oms-dark',
        },
      },
      ripple: true,
      filterMatchModeOptions: {
        text: [
          FilterMatchMode.STARTS_WITH,
          FilterMatchMode.CONTAINS,
          FilterMatchMode.NOT_CONTAINS,
          FilterMatchMode.ENDS_WITH,
          FilterMatchMode.EQUALS,
          FilterMatchMode.NOT_EQUALS,
        ],
        numeric: [
          FilterMatchMode.EQUALS,
          FilterMatchMode.NOT_EQUALS,
          FilterMatchMode.LESS_THAN,
          FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
          FilterMatchMode.GREATER_THAN,
          FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
        ],
        date: [
          FilterMatchMode.DATE_IS,
          FilterMatchMode.DATE_IS_NOT,
          FilterMatchMode.DATE_BEFORE,
          FilterMatchMode.DATE_AFTER,
        ],
      },
    }),
    // PrivilegeGuard,
    // RoleGuard,
    // RedirectGuard,
    // RedirectReportGuard,
    // RedirectCruscottiGuard,
    // ExpiredGuard,
    MessageService,
  ],
};
